import { Toast } from '@douyinfe/semi-ui';

export function toastError(err: unknown, defaultVal = '未知错误') {
  let msg = '';
  if (err instanceof Error) {
    msg = err.message;
  } else if (typeof err === 'string') {
    msg = err;
  }
  Toast.error(msg || defaultVal);
}
